import {
  Form,
  Input,
  Checkbox,
  Link,
  Button,
  Space,
} from '@arco-design/web-react';
import { FormInstance } from '@arco-design/web-react/es/Form';
import { IconLock, IconUser } from '@arco-design/web-react/icon';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import request from '@/request/request';
import { useHistory } from 'react-router-dom';

export default function LoginForm() {
  const formRef = useRef<FormInstance>();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [loginParams, setLoginParams, removeLoginParams] =
    useStorage('loginParams');

  const t = useLocale(locale);

  const [rememberPassword, setRememberPassword] = useState(!!loginParams);

  async function afterLoginSuccess(params, response) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    }
    const tokenInfo = response.tokenInfo;
    // 记录登录状态
    localStorage.setItem('tokenInfo', JSON.stringify(tokenInfo));

    const userInfo = response.userInfo;
    // 获取角色的权限
    if (userInfo.admin) {
      userInfo.resourceList = userInfo.resources;
    } else {
      if (userInfo.roles.length) {
        try {
          const roleResponse = await request(`/sec-user/noLevelList`,
            {
              data: {rid: userInfo.roles[0].id},
              method: 'post',
            }
          );
          // userInfo.resources = roleResponse.data?.resourceInfo || [];
          userInfo.resourceList = roleResponse.data || [];
        } catch (e) {}
      }
    }

    localStorage.setItem('userInfo', JSON.stringify(userInfo));

    window.location.href = '/';
  }

  function login(params) {
    setErrorMessage('');
    setLoading(true);
    request('/login', {
      data: {
        account: params.account,
        password: params.password,
      },
      method: 'POST',
    })
      .then((resp) => {
        if (resp.code === 200) {
          afterLoginSuccess(params, resp.data);
        } else {
          setErrorMessage(resp.message || t['login.form.login.errMsg']);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmitClick() {
    formRef.current.validate().then((values) => {
      login(values);
    });
  }

  // 读取 localStorage，设置初始值
  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);
    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);

  return (
    <div className={styles['login-form-wrapper']}>
      <div className={styles['login-form-title']}>{t['login.form.title']}</div>
      {/* <div className={styles['login-form-sub-title']}>账密登录</div> */}
      <div className={styles['login-form-error-msg']}>{errorMessage}</div>
      <Form
        className={styles['login-form']}
        layout="vertical"
        ref={formRef}
        initialValues={{ account: '', password: '' }}
      >
        <Form.Item
          field="account"
          rules={[{ required: true, message: '请输入账号' }]}
        >
          <Input
            prefix={<IconUser />}
            placeholder={'请输入账号'}
            onPressEnter={onSubmitClick}
          />
        </Form.Item>
        <Form.Item
          field="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password
            prefix={<IconLock />}
            placeholder={'请输入密码'}
            onPressEnter={onSubmitClick}
          />
        </Form.Item>
        <Space size={16} direction="vertical">
          <div className={styles['login-form-password-actions']}>
            <Checkbox checked={rememberPassword} onChange={setRememberPassword}>
              {t['login.form.rememberPassword']}
            </Checkbox>
            {/* <Link>{t['login.form.forgetPassword']}</Link> */}
          </div>
          <Button type="primary" long onClick={onSubmitClick} loading={loading}>
            {t['login.form.login']}
          </Button>
          {/* <Button
            type="text"
            long
            className={styles['login-form-register-btn']}
          >
            {t['login.form.register']}
          </Button> */}
        </Space>
      </Form>
    </div>
  );
}
